import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

import Questions from "./modules/newChampQuestions";
import Championship from "./modules/championship";
import _Championship from "./modules/championship/ChampionshipVuex";
import ChampTeam from "./modules/championship/ChampTeamVuex";
import Users from "./modules/users";
import Match from "./modules/championship/MatchVuex";
import Round from "./modules/championship/RoundVuex";
// import Details from './modules/championshipDetails'

const store = new Vuex.Store({
  modules: {
    Questions,
    Championship, //este é o antigo
    _Championship,
    ChampTeam,
    Match,
    Round,
    Users
  }
});

// Vue.store = store;

export default store;
